import { Dispatch } from "redux";
import { connect } from "react-redux";

import {
    UserForm as Presenter,
    UserFormDispatchProps,
    UserFormStateProps,
    UserFormOwnProps,
 } from "./presenter";
import { IUser, AuthState } from "../../models";
import {
    getNumUsers,
    getOrganisations,
    getLesserEqualRoles,
    getCreateUserLevel,
    getUpdateUserLevel,
    getCurrentUser,
} from "../../selectors";
import { LocalisationState } from "@localisation/models";
import { getLocale } from "@localisation/selectors";
import { Api } from "@api/index";

// Map the state entities to the component
function mapStateToProps(state: AuthState & LocalisationState, _ownProps: UserFormOwnProps) {
    const user = getCurrentUser(state);
    return {
        numUsers: getNumUsers(state),
        organisations: getOrganisations(state),
        roles: getLesserEqualRoles(state),
        createUserLevel: getCreateUserLevel(state),
        updateUserLevel: getUpdateUserLevel(state),
        currentUserOrganisation: user != null ? user.organisation : null,
        organisationsLastLoaded: state.auth.requests.organisationsIndexLastSuccess,
        rolesLastLoaded: state.auth.requests.rolesIndexLastSuccess,
        locale: getLocale(state),
    } as UserFormStateProps;
}

// Map the users store action to the component
function mapDispatchToProps(dispatch: Dispatch<AuthState>) {
    return {
        usersStore: (user: IUser) => {
            const action = Api.usersStore(user);
            dispatch(action);
            return action;
        },
        usersUpdate: (user: IUser) => {
            const action = Api.usersUpdate(user.id, user);
            dispatch(action);
            return action;
        },
    } as UserFormDispatchProps;
}

// Connect to Redux.
const UserForm = connect(mapStateToProps, mapDispatchToProps)(Presenter);

export { UserForm };
